import service from "../request";
const baseUrl = window.globalUrl.HOME_API;
// 商铺主页数据展示
export const dataDisplay = (params) => {
  return service({
    url: `${baseUrl}/mall/shop/dataDisplay`,
    method: 'get',
    params: params,
  })
}
// PC端商品列表

export const selectPcPageList = (params) => {
  return service({
    url: `${baseUrl}/mall/goods/selectPcPageList`,
    method: 'get',
    params: params,
  })
}
// 商品类别列表
export const tree = (params) => {
  return service({
    // isForm:true,
    url: `${baseUrl}/mall/goods-category/tree`,
    method: 'get',
    params: params,

  })
}
//上架商品
export const saveGoods = (params) => {
  return service({
    url: `${baseUrl}/mall/goods/saveGoods`,
    method: 'post',
    data: params
  })
}
// 小程序/PC端商品详情
export const appletPcDetail = (params) => {
  return service({
    url: `${baseUrl}/mall/goods/appletPcDetail`,
    method: 'get',
    params: params
  })
}
// 删除商品
export const deleteGoods = (params) => {
  return service({
    url: `${baseUrl}/mall/goods/deleteGoods`,
    method: 'post',
    isForm: true,
    params: params
  })
}
// 程序/PC端商品列表

export const appletPcPageList = (params) => {
  return service({
    url: `${baseUrl}/mall/goods/appletPcPageList`,
    method: 'get',
    params: params
  })
}
// PC端订单列表
export const selectPcOrderPageList = (params) => {
  return service({
    url: `${baseUrl}/mall/order/selectPcOrderPageList`,
    method: 'get',
    params: params
  })
}

// 修改商品
export const updateGoods = (params) => {
  return service({
    url: `${baseUrl}/mall/goods/updateGoods`,
    method: 'post',
    data: params
  })
}
// 订单详情
export const detail = (params) => {
  return service({
    url: `${baseUrl}/mall/order/detail`,
    method: 'get',
    params: params
  })
}
// 查询快递公司
export const selectShipCompany = (params) => {
  return service({
    url: `${baseUrl}/mall/ship-company/selectShipCompany`,
    method: 'get',
    params: params
  })
}
// 分页查询客服信息
export const selectUserList = (params) => {
  return service({
    url: `${baseUrl}/admin/user/selectUserList`,
    method: 'get',
    params: params
  })
}
// 发货
export const deliverGoods = (params) => {
  return service({
    url: `${baseUrl}/mall/order/deliverGoods`,
    method: 'post',
    data: params
  })
}

//根据快递公司id获取商铺的电子面单账号
export const getPartnerIdByShipCompanyId = (params) => {
  return service({
    url: `${baseUrl}/mall/shop/getPartnerIdByShipCompanyId`,
    method: 'get',
    params: params
  })
}

//客服管理-新增/更新客服信息
export const saveOrUpdateUser = (params) => {
  return service({
    url: `${baseUrl}/admin/user/saveOrUpdateUser`,
    method: "post",
    data: params,
  });
};
// 删除客服信息
export const deleteUser = (params) => {
  return service({
    url: `${baseUrl}/admin/user/deleteUser`,
    method: "post",
    data: params,
    isForm: true,
  });
};
//商品评论列表
export const list = (params) => {
  return service({
    url: `${baseUrl}/mall/comment/list`,
    method: 'get',
    params: params
  })
}
//购物车列表
export const shopList = (params) => {
  return service({
    url: `${baseUrl}/mall/cart/list`,
    method: 'get',
    params: params
  })
}
//加入购物车
export const addCart = (params) => {
  return service({
    url: `${baseUrl}/mall/cart/addCart`,
    method: "post",
    data: params,
    // isForm: true,
  });
};
//获取收货地址数据

export const addressList = (params) => {
  return service({
    url: `${baseUrl}/mall/address/list`,
    method: "get",
    params: params,
    // isForm: true,
  });
};
//删除购物车

export const shopDelete = (params) => {
  return service({
    method: "post",
    url: `${baseUrl}/mall/cart/delete`,
    params: params,
    isForm: true,
  });
};
//购物车货物数量变更

export const updateProductNum = (params) => {
  return service({
    method: "post",
    url: `${baseUrl}/mall/cart/updateProductNum`,
    data: params,
    isForm: true,
  });
};
//新增收货地址


export const createAddress = (params) => {
  return service({
    url: `${baseUrl}/mall/address/create`,
    method: "post",
    data: params,

  });
};
// 删除收货地址
export const deleteAddress = (params) => {
  return service({
    url: `${baseUrl}/mall/address/delete`,
    method: "post",
    data: params,
    isForm: true,
  });
};
//地址详情
export const detailAddress = (params) => {
  return service({
    url: `${baseUrl}/mall/address/detail`,
    method: "get",
    params: params,

  });
};
// 修改收货地址
export const update = (params) => {
  return service({

    url: `${baseUrl}/mall/address/update`,
    method: "post",
    data: params,

  });
};
//修改默认地址
export const setDefault = (params) => {
  return service({
    url: `${baseUrl}/mall/address/setDefault`,
    method: "post",
    data: params,
    isForm: true,
  });
};
// 我的订单列表(用户)
export const myOrder = (params) => {
  return service({
    url: `${baseUrl}/mall/order/myOrder`,
    method: "get",
    params: params,

  });
};
//取消订单
export const cancelOrder = (params) => {
  return service({
    url: `${baseUrl}/mall/order/cancelOrder`,
    method: "post",
    data: params,
    isForm: true,
  });
};
//商品评论列表
export const commentlist = (params) => {
  return service({
    url: `${baseUrl}/mall/comment/list`,
    method: "get",
    params: params,

  });
};
//订单提交


export const orderSubmit = (params) => {
  return service({
    url: `${baseUrl}/mall/order/submit`,
    method: "post",
    data: params,
    // isForm: true,
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  });
};

// 生成支付二维码
export const generatePayCode = (params) => {
  return service({
    url: `${baseUrl}/mall/payment/generatePayCode`,
    method: "get",
    params: params,
    isForm: true,
  });
};


// 购物车下单
export const cartOrder = (params) => {
  return service({
    url: `${baseUrl}/mall/cart/cartOrder`,
    method: "post",
    data: params,

  });
};
// 订单是否完成付款

export const checkOrderPayStatus = (params) => {
  return service({
    url: `${baseUrl}/mall/order/checkOrderPayStatus`,
    method: "get",
    params: params,
  });
};
//订单详情

export const orderDetail = (params) => {
  return service({
    url: `${baseUrl}/mall/order/detail`,
    method: "get",
    params: params,
  });
};
//查看物流信息
export const getLogisticsInfo = (params) => {
  return service({
    url: `${baseUrl}/mall/order/getLogisticsInfo`,
    method: "get",
    params: params,
  });
};
//确认收货
export const confirmReceipt = (params) => {
  return service({
    url: `${baseUrl}/mall/order/confirmReceipt`,
    method: "post",
    data: params,
    isForm: true,
  });
};
// 新增用户评论
export const commitCreate = (params) => {
  return service({
    url: `${baseUrl}/mall/comment/create`,
    method: "post",
    data: params,
    // isForm: true,
  });
};
// 商品评论统计数据
export const statisticsData = (params) => {
  return service({
    url: `${baseUrl}/mall/comment/statisticsData`,
    method: "get",
    params: params,
    //  isForm: true,
  });
};
//显示订单管理的五个数量

export const getPcOrderNumber = (params) => {
  return service({
    url: `${baseUrl}/mall/order/getPcOrderNumber`,
    method: "get",
    params: params,
    //  isForm: true,
  });
};
